import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import '../../utils/responsive.es.js';
import { useIsDestroyed } from '../../hooks/useIsDestroyed/useIsDestroyed.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
function importDayJSLocale(language) {
  const importFunctions = {
    en: () => import('dayjs/locale/en.js'),
    fr: () => import('dayjs/locale/fr.js'),
    de: () => import('dayjs/locale/de.js'),
    it: () => import('dayjs/locale/it.js'),
    ja: () => import('dayjs/locale/ja.js'),
    pt: () => import('dayjs/locale/pt.js'),
    es: () => import('dayjs/locale/es.js')
  };
  const importFunction = importFunctions[language];
  return importFunction ? importFunction() : Promise.reject("Unsupported locale");
}
const useUpdatingTimestamp = ({ createdAt, locale }) => {
  const [timestamp, setTimestamp] = useState(dayjs(createdAt).fromNow());
  const isDestroyed = useIsDestroyed();
  useEffect(() => {
    if (locale) {
      importDayJSLocale(locale).then(() => {
        if (!isDestroyed.current) {
          dayjs.locale(locale);
          setTimestamp(dayjs(createdAt).fromNow());
        }
      }).catch(() => {
        if (!isDestroyed.current) {
          dayjs.locale("en");
          setTimestamp(dayjs(createdAt).fromNow());
        }
      });
    }
  }, [createdAt, isDestroyed, locale]);
  useEffect(() => {
    const createdAtDayjs = dayjs(createdAt);
    const diffInSeconds = Math.abs(createdAtDayjs.diff(dayjs(), "second"));
    const sInHour = 3600;
    let intervalId = void 0;
    if (diffInSeconds < sInHour) {
      intervalId = setInterval(() => {
        setTimestamp(createdAtDayjs.fromNow());
      }, 6e4);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [createdAt, timestamp]);
  return { timestamp };
};
const RichTimestamp = ({
  createdAt,
  checkSamePeriod,
  locale = "en",
  format = "ll"
}) => {
  const { timestamp } = useUpdatingTimestamp({ createdAt, locale });
  const createdAtDayJs = dayjs(createdAt);
  const fullLocalizedDate = createdAtDayJs.format(format);
  if (createdAtDayJs.isAfter(dayjs())) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, fullLocalizedDate);
  }
  if (!checkSamePeriod || createdAtDayJs.diff(dayjs(), checkSamePeriod) >= 0) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, timestamp);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, fullLocalizedDate);
};

export { RichTimestamp };
//# sourceMappingURL=RichTimestamp.es.js.map
